import classNames from 'classnames';
import React, { useState } from 'react';

import { Button, ButtonVariant, Icon, Typography } from '@/shared/ui';

import './HeaderWithGoBackButton.scss';

export interface HeaderWithGoBackButtonProps {
  header: React.ReactNode;
  className?: string;
  titleExpandeble?: boolean;
  hideTitleOverFlow?: boolean;
  goBackText: string;
  onGoBack?: () => void;
}

export const HeaderWithGoBackButton = React.memo<HeaderWithGoBackButtonProps>(function ({
  header,
  className = '',
  titleExpandeble = false,
  hideTitleOverFlow = false,
  goBackText,
  onGoBack,
}) {
  const [isTitleExpanded, setIsTitleExpanded] = useState<boolean>(true);

  const toggleContentSize = (value: boolean): void => {
    setIsTitleExpanded(value);
  };
  return (
    <div className={classNames('header-with-go-back-button', { [className]: className })}>
      <div className="header-with-go-back-button__title-container">
        <div
          className={classNames('header-with-go-back-button__title', {
            'header-with-go-back-button__title--expanded': isTitleExpanded && !hideTitleOverFlow,
          })}
        >
          {header}
        </div>

        {titleExpandeble && !hideTitleOverFlow && (
          <button
            className="header-with-go-back-button__title-toggler toggler"
            type="button"
            onClick={(): void => toggleContentSize(!isTitleExpanded)}
          >
            {isTitleExpanded ? 'Менше' : 'Більше'}
            <span className="header-with-go-back-button__title-toggler__icon-container">
              <Icon
                className={classNames({
                  expanded: isTitleExpanded,
                })}
                name="arrow_right"
              />
            </span>
          </button>
        )}
      </div>
      {onGoBack && (
        <Button className="header-with-go-back-button__button" variant={ButtonVariant.GHOST} onClick={onGoBack}>
          <Icon name="arrow_back" />
          <Typography as="span">{goBackText}</Typography>
        </Button>
      )}
    </div>
  );
});
